import React from 'react';
import { Download, Trash2 } from 'lucide-react';
import { formatDateTime } from '../../kit/time';
import { money } from './formParts';

// Saved worksheets for the logged-in user, newest first (ticket 215).
function figure(w) {
  if (!w.complete) return null;
  if (w.form_id === '92') {
    const s = w.summary;
    if (!s) return null;
    return `Income ${money(s.add_to_income)} · Liabilities ${money(s.add_to_liabilities)}`;
  }
  return w.qualifying_monthly == null ? null : `${money(w.qualifying_monthly)}/mo`;
}

export function SavedWorksheets({ worksheets, onOpen, onDownload, onDelete }) {
  if (!worksheets || worksheets.length === 0) return null;
  return (
    <div className="space-y-2" data-testid="saved-worksheets">
      <div className="text-[11px] uppercase tracking-wide font-bold text-slate-500">Saved worksheets</div>
      {worksheets.map((w) => {
        const shown = figure(w);
        return (
          <div key={w.worksheet_id} className="rounded-lg border border-slate-200 px-3 py-2 flex flex-wrap items-center gap-3" data-testid={`saved-${w.worksheet_id}`}>
            <span className="text-[10px] font-bold px-1.5 py-0.5 rounded bg-slate-100 text-slate-700">Form {w.form_id}</span>
            <div className="flex-1 min-w-0">
              <div className="text-sm font-semibold text-brand-navy truncate">{w.borrower_name || 'No borrower name'}</div>
              <div className="text-[11px] text-slate-500">{formatDateTime(w.updated_at)}</div>
            </div>
            {shown
              ? <div className="text-sm font-bold text-brand-accent" data-testid={`saved-figure-${w.worksheet_id}`}>{shown}</div>
              : <div className="text-sm font-bold text-amber-600" data-testid={`saved-incomplete-${w.worksheet_id}`}>Incomplete</div>}
            <button type="button" onClick={() => onOpen(w.worksheet_id)} className="text-xs font-semibold text-brand-navy underline" data-testid={`saved-open-${w.worksheet_id}`}>Open</button>
            <button
              type="button"
              onClick={() => onDownload(w.worksheet_id)}
              disabled={!w.complete}
              title={w.complete ? undefined : 'Incomplete worksheets have no PDF.'}
              className="p-2 hover:bg-slate-100 rounded-lg disabled:opacity-40"
              aria-label="Download PDF"
              data-testid={`saved-download-${w.worksheet_id}`}
            ><Download size={13} /></button>
            <button
              type="button"
              onClick={() => onDelete(w.worksheet_id)}
              className="p-2 hover:bg-red-50 rounded-lg"
              aria-label="Delete worksheet"
              data-testid={`saved-delete-${w.worksheet_id}`}
            ><Trash2 size={13} className="text-red-500" /></button>
          </div>
        );
      })}
    </div>
  );
}
